module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAABGdBTUEAALGPC/xhBQAAAM1JREFUKBWdkUsOwiAQhqFrQxdwBIPnMXbTTQ/XTTfV+9h4BFh04lqcnxZTI2jiJC3z/IYZJHWdJu9HEcJBCDGpum7UMDjWfwq1raF5HjnRCimvSutGouofaA6m+t5XAEIBHV3YtOiKJojlpARDbgRCeUF5bDYtOXfOQeM0aUysiC+CWjAgceRFXf6xgGFsWf4mZcwpFXyLJcYHEIFcYfQXGiUYziwwFuP1V0Al5Q2+Rwh7Pt5uDf9WikAkYfl3ossKEgDvtD6mFWxBSX8CA6SC3MN0n7MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/arrow-down-red.png
// module id = 583
// module chunks = 35783957827783